module.exports = __webpack_public_path__ + "img/CNN.68d79baf.jpeg";